import { IApplicationState } from '../../types/redux';

export function filterBusinessAppointmentsIdsSelector(state: IApplicationState): Array<number> {
  return state.businessAppointments.filterBusinessAppointmentsIds;
}
